// DS: PO28
/** Popup prompting users to verify their email address */ import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useContext, useCallback } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { FirstTimeFlag } from '../redux/firstTimeFlags';
import VerificationPopupDesktop from './VerificationPopupDesktop';
import VerificationPopupMobile from './VerificationPopupMobile';
export const VerificationPopup = (_param)=>{
    var { dropFlagOnClose , dropFirstTimeFlag , onClose  } = _param, props = _object_without_properties(_param, [
        "dropFlagOnClose",
        "dropFirstTimeFlag",
        "onClose"
    ]);
    const isMobile = useContext(MobileContext);
    const handleClose = useCallback(()=>{
        if (dropFlagOnClose) {
            dropFirstTimeFlag({
                flag: FirstTimeFlag.WelcomePopupNotClosed
            });
        }
        return onClose && onClose();
    }, [
        dropFlagOnClose,
        dropFirstTimeFlag,
        onClose
    ]);
    return isMobile ? /*#__PURE__*/ React.createElement(VerificationPopupMobile, _extends({
        onClose: handleClose
    }, props)) : /*#__PURE__*/ React.createElement(VerificationPopupDesktop, _extends({
        onClose: handleClose
    }, props));
};
VerificationPopup.displayName = 'VerificationPopup';
export default VerificationPopup;
